import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { notifyMe } from "@/lib/api";

export default function NotifyMeModal({
  open,
  onOpenChange,
  productSlug,
  productName,
}) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await notifyMe(email, productSlug);
      setDone(true);
      if (res.already_subscribed) {
        toast("You're already on the list.");
      } else {
        toast.success("You're on the list");
      }
    } catch (err) {
      toast.error("Something went wrong", {
        description: err?.response?.data?.detail || "Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (v) => {
    if (!v) {
      setTimeout(() => {
        setDone(false);
        setEmail("");
      }, 250);
    }
    onOpenChange(v);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        data-testid="notify-me-modal"
        className="bg-[#0c0c0c] border border-[#2a2a2a] text-white max-w-md p-0 rounded-none"
      >
        <div className="p-10">
          <span className="font-label text-[#d4af37]">— Coming Soon —</span>
          <DialogTitle asChild>
            <h3 className="mt-3 font-display text-3xl leading-tight">
              Be the first to know.
            </h3>
          </DialogTitle>
          <DialogDescription asChild>
            <p className="mt-3 text-[#a3a3a3] font-light">
              Leave your email and we'll notify you when{" "}
              <span className="text-white">{productName}</span> drops.
            </p>
          </DialogDescription>

          {!done ? (
            <form
              onSubmit={onSubmit}
              className="mt-8"
              data-testid="notify-me-form"
            >
              <input
                type="email"
                required
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="notify-me-email-input"
                className="afrqa-input"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="notify-me-submit-btn"
                className="btn-gold w-full mt-8"
              >
                {loading ? "Sending…" : "Notify Me"}
              </button>
            </form>
          ) : (
            <div
              className="mt-8 border border-[#d4af37]/30 p-6 text-center"
              data-testid="notify-me-success"
            >
              <p className="font-editorial italic gold-text-gradient text-2xl">
                You're on the list.
              </p>
              <p className="mt-3 text-[#a3a3a3] font-light">
                We'll be in touch before launch.
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
